import LeadPartyApi from "../../service/LeadPartyService";
import DocumentApi from "../../service/DocumentService";

export default {
  name: "user-card",
  props: {
    expansionPanel: {
      type: Boolean,
      default: false
    },
    leadPartyId: {
      type: Number,
      required: true
    },
    tckn: {
      type: String,
      required: true
    },
    pageType: {
      type: String
    },
    processId: {
      type: String
    },
    note: {
      type: Object
    }
  },
  data: function () {
    return {
      imageData: "",
      customerCard: [
        {
          key: "fullName"
        },
        {
          key: "tckn"
        },
        {
          key: "gender"
        },
        {
          key: "motherName"
        },
        {
          key: "fatherName"
        },
        {
          key: "birthPlace"
        },
        {
          key: "birthDate"
        },
        {
          key: "identityValidityDate"
        },
        {
          key: "identitySerialNo"
        },
        {
          key: "addressText"
        }
      ],
      surveyResult: {},
      questionsAndAnswers: [],
      isLoadingCustomerDetail: false,
      isLoadingBiometricImage: false,
      panel: 0,
      nfcStatus: "",
      isNfcSuccess: false
      };
  },
  async created() {
    debugger;
    this.SHOW = true;
    if (this.pageType === "ProcessList" || this.pageType === "LeadPartyList") {
      this.customerCard.splice(
        1,
        0,
        {
          key: "phone"
        },
        {
          key: "email"
        }
      );
      this.customerCard.splice(3, 8);
    } else if (this.pageType === "VideoConversation") {
      this.customerCard.splice(1, 0, {
        key: "phone"
      });
    }

    console.log(this.processId);
    await this.retrieveCustomerDetail(this.leadPartyId);
    await this.retriveNfcStatus(this.processId);
    this.retrieveBiometricImage(this.processId, this.isNfcSuccess);
  },

  computed: {
    isLoading: function () {
      return this.isLoadingCustomerDetail || this.isLoadingBiometricImage;
    }
  },
  methods: {
    async retriveNfcStatus(processId) {
      return new Promise(resolve => {
        console.log("NFC pROCESSıD", processId);
        LeadPartyApi.getLeadPartyNfcInfo(this, processId, response => {
          if (response != null) {
            if (response == "success") {
              this.nfcStatus = "Başarılı";
              this.isNfcSuccess = true;
              this.$emit("setNfcStatusUserCard", true);
            } else {
              this.nfcStatus = "Başarısız";
              this.isNfcSuccess = false;
              this.$emit("setNfcStatusUserCard", false);
            }

            console.log("nfc response:=" + response);
            console.log(this.nfcStatus)
          } else {
            this.nfcStatus = "BULUNAMADI";
          }
          resolve(true)
        });
      })
    },
    async retrieveCustomerDetail(leadPartyId) {
      return new Promise(resolve => {
        this.isLoadingCustomerDetail = true;
        LeadPartyApi.get(
          this,
          leadPartyId,
          response => {
            if (response && response.leadPartyDTO) {
              this.customerCard.forEach(info => {
                if (response.leadPartyDTO[info.key]) {
                  info.value = response.leadPartyDTO[info.key];
                }
              });
              if (
                this.pageType === "VideoConversation" &&
                response.leadPartyDTO.addressText
              ) {
                this.$parent.addressApproved = true;
              }

              if (response.leadPartyDTO.questionaryLeadResultDTO) {
                if (response.leadPartyDTO.questionaryLeadResultDTO.answerList) {
                  response.leadPartyDTO.questionaryLeadResultDTO.answerList.forEach(
                    answer => {
                      if (
                        !this.questionsAndAnswers.some(
                          item => item.question === answer.question.description
                        )
                      ) {
                        this.questionsAndAnswers.push({
                          question: answer.question.description,
                          answer: answer.questionOptionList
                            .map(option => option.description)
                            .join(",")
                        });
                      }
                    }
                  );
                }
                if (
                  response.leadPartyDTO.questionaryLeadResultDTO.riskGroupDTO
                ) {
                  this.surveyResult = {
                    colorCode:
                      response.leadPartyDTO.questionaryLeadResultDTO
                        .riskGroupDTO.colorCode,
                    name:
                      response.leadPartyDTO.questionaryLeadResultDTO
                        .riskGroupDTO.name
                  };
                }
              }
            }
            if (this.processId) {
              this.customerCard.push({
                key: "processId",
                value: this.processId
              });
            }
            this.processId = response.leadPartyDTO.actualProcessId;
            this.isLoadingCustomerDetail = false;
            resolve(true);
          },
          error => {
            console.log(error);
            this.isLoadingCustomerDetail = false;
          }
        );

      });
    },
    retrieveBiometricImage(processId, nfcStatus) {
      this.isLoadingBiometricImage = true;
      console.log("retrieve Biometric Image NFC :" + nfcStatus);
      var sourceType = "";
      var sourceValue = "";
      if (nfcStatus) {
        sourceType = "NFC";
        sourceValue = "NFCBF";
      } else {
        sourceType = "OCR";
        sourceValue = "OCRBF";
      }
      console.log("Source Type : " + sourceType);
      console.log("Source Value : " + sourceValue);
      DocumentApi.getRecent(
        this,
        sourceType,
        this.processId,
        sourceValue,
        response => {
          if (
            response &&
            response.documentFileWithIdDTO &&
            response.documentFileWithIdDTO.documentFileDTO
          ) {
            this.imageData =
              "data:image/png;base64," +
              response.documentFileWithIdDTO.documentFileDTO.base64Bytes;
          }
          this.isLoadingBiometricImage = false;
        },
        error => {
          console.log(error);
          this.isLoadingBiometricImage = false;
        }
      );
    },
    onClickOk() {
      this.$emit("onClickOkCustomerCard");
    },
    formatValue(key, value) {
      if (value) {
        if (key === "phone") {
          return this.$options.filters.formatPhoneNumber(value);
        } else if (key === "birthDate") {
          return this.$options.filters.formatMsToDate(value);
        } else if (key === "identityValidityDate") {
          return this.$options.filters.formatMsToDate(value);
        } else if (key === "gender") {
          return this.$t(value);
        } else {
          return value;
        }
      } else {
        return this.$t("unknown");
      }
    },
    getImageData() {
      return this.imageData;
    }

  }
};


// WEBPACK FOOTER //
// ./src/components/mixin/UserCard.js